import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticatedRiderService } from '../services';

export function AuthGuard(): CanActivateFn {
  return (route, state) => {
    const router = inject(Router);
    const authenticatedRiderService = inject(AuthenticatedRiderService);

    if (authenticatedRiderService.isLoggedIn()) {
      return true;
    }

    const redirectUrl = state.url;

    return router.createUrlTree(['/login'], {
      queryParams: { redirectUrl }
    });
  };
}
